(ns cljsjs.react-easy-crop
  (:require ["react-easy-crop" :as react-easy-crop]))

;;npm install react-easy-crop
(js/goog.exportSymbol "ReactEasyCrop" react-easy-crop)
